<template>
  <div v-if="enabled" class="captcha-field">
    <div ref="container"></div>
    <div v-if="failed" class="text-danger text-start small mt-1">
      {{ $t('auth.register.captchaFailed') }}
    </div>
  </div>
</template>

<script setup>
/**
 * The bot challenge on the sign-up form.
 *
 * Renders nothing when no site key is configured, so a developer without a reCAPTCHA
 * site key still gets a working form. The parent owns the token and passes it to the
 * register call; this component only owns the widget.
 */

// 1. Vue core
import { ref, onMounted, watch } from 'vue'

// 2. Composables
import { useCaptcha } from '@/composables/useCaptcha'

const emit = defineEmits(['update:token'])

const container = ref(null)
const { enabled, token, failed, render, reset } = useCaptcha()

watch(token, value => emit('update:token', value))

onMounted(() => {
  render(container.value)
})

// reCAPTCHA tokens are single-use: the parent calls this after every submit attempt,
// successful or not, or the next attempt sends a token the server has already spent.
defineExpose({ reset })
</script>

<style scoped>
.captcha-field {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
